import { Vector4 } from "three";
import getMaterialWithUniforms from "../../instancing/materials/getMaterialWithUniforms";
import RectangleMesh from "../../instancing/Meshes/RectangleMesh";
import ParticleMesh from "../../instancing/Meshes/ParticleMesh";
import {
  baseDict,
  normTexture,
  colorMap,
  textureCoordsMap,
  textureCoords,
} from "../../constants/bases";

export function getBaseRectMesh() {
  const conf = {
    rgbaCode: 1,
    posX: 1,
    posY: 1,
  };

  const materialUniforms = getMaterialWithUniforms({ antialias: true })
    .setPaddingX([0.25, -0.25, 0.25, -0.25])
    .setPaddingY([0, 0, 0, 0])
    .setOffset([0, 0, 0, 0])
    .setColorMap(colorMap);

  return new RectangleMesh(materialUniforms, conf);
}

export function getLettersMesh() {
  const conf = {
    rgbaCode: 1,
    posX: 1,
    posY: 1,
    textureCoordsInd: 1,
  };
  const materialConf = {
    disableRaycast: true,
    textureConf: {},
    transparent: true,
    alphaTest: 0,
  };

  const materialUniforms = getMaterialWithUniforms(materialConf)
    .setTexture(normTexture)
    .setOffset([0, 0])
    .setPointSize(13)
    .setTextureCoordMap(textureCoords)
    .setColorMap([new Vector4(1, 1, 1, 1)]);

  return new ParticleMesh(materialUniforms, conf);
}

export function drawBaseRect(bases, mesh) {
  const count = bases.length;
  const isAppend = true;
  const setX = mesh.updateX({ count, isAppend });
  const setY = mesh.updateY({ count, isAppend });
  const setRgb = mesh.updateRgba({ count, isAppend });

  for (let i = 0; i < count; i++) {
    const { code, region } = bases[i];
    const { g0, g1 } = region;
    const rgb = baseDict[code].colorInd;
    setX(i, g0, g1, g0, g1);
    setY(i, 0, 0, 1, 1);
    setRgb(i, rgb, rgb, rgb, rgb);
  }
}

export function drawBaseLetter(bases, mesh) {
  const count = bases.length;
  const isAppend = true;
  const setX = mesh.updateX({ count, isAppend });
  const setY = mesh.updateY({ count, isAppend });
  const setTextureCoordInd = mesh.updateTextureCoordsInd({ count, isAppend });

  for (let i = 0; i < count; i++) {
    const { code, region } = bases[i];
    const { g0 } = region;
    setX(i, g0 + 0.5);
    setY(i, 0.5);
    setTextureCoordInd(i, textureCoordsMap[code]);
  }
}
